export const SUPPORTED_WALLET_CONFIG_BACKGROUND_FORMATS = [
  {
    ext: 'png',
    mime: ['image/png'],
  },
  {
    ext: 'jpg',
    mime: ['image/jpeg'],
  },
  {
    ext: 'jpeg',
    mime: ['image/jpeg'],
  },
] as const;
